import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import moment from 'moment-timezone';
import { task, timeout } from 'ember-concurrency';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<span role=\'timer\'>{{this.timeInWords}}</span>");

var _dec, _class, _descriptor;
let BbTimeAgoComponent = (_dec = task({
  restartable: true
}), _class = class BbTimeAgoComponent extends Component {
  get timeInWords() {
    this._tick; // dipendenza sul refresh periodico
    const zone = this.args.time_zone || 'Europe/Rome';
    const date = this.args.date;
    return date ? moment(date).tz(zone).fromNow() : '';
  }
  constructor() {
    super(...arguments);
    // Contatore incrementato dal tick periodico: forza il ricalcolo del getter
    // ogni 5s mantenendolo comunque reattivo ai cambi di @date / @time_zone
    // (che altrimenti restavano stale fino al tick successivo).
    _initializerDefineProperty(this, "_tick", _descriptor, this);
    this.tickTask.perform();
  }
  *tickTask() {
    while (true) {
      yield timeout(5000);
      this._tick++;
    }
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this.tickTask.cancelAll();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_tick", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "tickTask", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "tickTask"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbTimeAgoComponent);

export { BbTimeAgoComponent as default };
//# sourceMappingURL=bb-time-ago.js.map
